<!DOCTYPE html>
<html lang="bs">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <link rel="stylesheet" href="hero.scss"> <!-- Dodaj svoj SCSS -->
</head>
<body>

  <nav class="hero-nav-bar">
  <!-- Logo lijevo sa hover glow -->
 <div class="top-title">
  <img src="/logo.png" alt="Restoran Kockica Moševac Logo" class="logo-image" />
</div>

  
  <!-- Hamburger button -->
  <button class="hamburger" [class.active]="menuOpen" (click)="toggleMenu()" aria-label="Menu">
    <span></span><span></span><span></span>
  </button>
  
  <!-- Nav meni -->
  <ul class="nav-menu" [class.mobile-open]="menuOpen">
    <li>
      <a href="#hero-section" class="nav-link" (click)="onNavClick($event, 'hero-section')">
        Početna
      </a>
    </li>
    <li>
      <a href="#menu-section" class="nav-link" (click)="onNavClick($event, 'menu-section')">
        Menu
      </a>
    </li>
    <li>
      <a href="#galerija" class="nav-link" (click)="onNavClick($event, 'galerija')">
        Galerija & O nama
      </a>
    </li>
    <li>
      <a href="#specijaliteti" class="nav-link" (click)="onNavClick($event, 'specijaliteti')">
        Specijaliteti
      </a>
    </li>
    <li>
      <a href="#kontakt" class="nav-link" (click)="onNavClick($event, 'kontakt')">
        Kontakt
      </a>
    </li>
  </ul>
</nav>


  <!-- Hero background + tekst -->
  <section id="hero-section" class="hero-section">
    <div class="hero-image">
      <!-- 🎥 VIDEO UMJESTO SLIKE -->
      <video #mainVideo 
             class="main-image" 
             autoplay 
             muted 
             loop 
             playsinline 
             preload="auto">
        <source src="naslovnivideo.mp4" type="video/mp4">
      </video>
    </div>
    
    <div class="hero-message">
       <h3>
    <span class="hero-line hero-main">DOBRODOŠLI</span>
    <span class="hero-line hero-small">U</span>
    <span class="hero-line hero-main">KOCKICU</span>
  </h3>
    </div>
    
    <a href="#menu-section" class="hero-button">Pogledaj menu</a>
  </section>

  <!-- Menu sekcija – OSTALO ISTO -->
  <section id="menu-section" class="menu-tabs-section">
    <div class="container">
      <h2 class="section-title">Odaberite iz ponude</h2>
      
      <!-- Tabs kontrole -->
      <ul class="tabs-controls">
        <li class="tab-btn active" data-tab="dorucak">Doručak</li>
        <li class="tab-btn" data-tab="rostilj">Jela sa roštilja</li>
        <li class="tab-btn" data-tab="narudzba">Jela po narudžbi</li>
        <li class="tab-btn" data-tab="pizza">Pizza</li>
        <li class="tab-btn" data-tab="prilozi">Prilozi</li>
         <li class="tab-btn" data-tab="salate">Salate</li>
        <li class="tab-btn" data-tab="sladoled">Sladoledi/Palačinci</li>
        <li class="tab-btn" data-tab="deserti">Kolači</li>
        <li class="tab-btn" data-tab="napitci">Topli napitci</li>
        <li class="tab-btn" data-tab="bezalkoholno">Bezalkoholno pivo</li>
        <li class="tab-btn" data-tab="prirodni">Prirodni sokovi</li>
        <li class="tab-btn" data-tab="bezalkoholna">Bezalkoholna pića</li>
        <li class="tab-btn" data-tab="alkohol">Alkoholna pića</li>
        <li class="tab-btn" data-tab="pivo">Pivo</li>
        <li class="tab-btn" data-tab="vino">Vino</li>
        <li class="tab-btn" data-tab="plate">Hladne plate</li>
      </ul>
      
      <!-- Tabs sadržaj -->
      <div class="tabs-content">
      <div class="tab-panel active" id="dorucak">
          <h3>Doručak</h3>
          <div class="menu-item"><span>Omlet</span><span>6 KM</span></div>
          <div class="menu-item"><span>Omlet sa sirom</span><span>7 KM</span></div>
          <div class="menu-item"><span>Omlet sa suhim mesom</span><span>8 KM</span></div>
          <div class="menu-item"><span>Uštipci sa pavlakom</span><span>6 KM</span></div>
          <div class="menu-item"><span>Crispy sendvič</span><span>7 KM</span></div>
          <div class="menu-item"><span>Domaća lepinica</span><span>10 KM</span></div>
          <div class="menu-item"><span>Pogačica sa piletinom</span><span>10 KM</span></div>
          <div class="menu-item"><span>Pogačica sa teletinom</span><span>12 KM</span></div>
          <div class="menu-item"><span>Pura</span><span>6 KM</span></div>
          <div class="menu-item"><span>Tortilja</span><span>7 KM</span></div>
        </div>
        <!-- JELA SA ROŠTILJA - poslije doručka -->
          <div class="tab-panel" id="rostilj">
            <h3>Jela sa roštilja</h3>
            
            <div class="menu-item"><span>Ćevapi velika porcija</span><span>10 KM</span></div>
            <div class="menu-item"><span>Ćevapi srednja porcija</span><span>8 KM</span></div>
            <div class="menu-item"><span>Ćevapi mala porcija</span><span>6 KM</span></div>
            <div class="menu-item"><span>Ćevapi u kajmaku mali</span><span>8 KM</span></div>
            <div class="menu-item"><span>Ćevapi u kajmaku veliki</span><span>12 KM</span></div>
            <div class="menu-item"><span>MIX u lepini</span><span>12 KM</span></div>
            <div class="menu-item"><span>Hamburger</span><span>6 KM</span></div>
            <div class="menu-item"><span>Cheeseburger</span><span>7 KM</span></div>
            <div class="menu-item"><span>Pljeskavica</span><span>13 KM</span></div>
            <div class="menu-item"><span>Punjena pljeskavica</span><span>15 KM</span></div>
            <div class="menu-item"><span>Sudžukice</span><span>13 KM</span></div>
            <div class="menu-item"><span>Burger menu</span><span>11 KM</span></div>
          </div>
            <!-- JELA PO NARUDŽBI - poslije roštilja tab-panela -->
          <div class="tab-panel" id="narudzba">
            <h3>Jela po narudžbi</h3>
            
            <div class="menu-item"><span>Fileti sa prilogom</span><span>13 KM</span></div>
            <div class="menu-item"><span>Fileti sa prilogom(125 gr)</span><span>8 KM</span></div>
            <div class="menu-item"><span>Otkošteni batak sa prilogom</span><span>10 KM</span></div>
            <div class="menu-item"><span>Pileći ražnjići sa prilogom</span><span>13 KM</span></div>
            <div class="menu-item"><span>Teleći ražnjići sa prilogom</span><span>17 KM</span></div>
            <div class="menu-item"><span>Teleća peka</span><span>18 KM</span></div>
            <div class="menu-item"><span>Kockica plata (1osoba)</span><span>15 KM</span></div>
            <div class="menu-item"><span>Kockica plata (2osobe)</span><span>40 KM</span></div>
            <div class="menu-item"><span>Kockica pileći menu 400 gr</span><span>15 KM</span></div>
            <div class="menu-item"><span>Bečka pileća šnicla</span><span>15 KM</span></div>
            <div class="menu-item"><span>Bečka teleća šnicla</span><span>18 KM</span></div>
            <div class="menu-item"><span>Piletina sa susamom</span><span>15 KM</span></div>
            <div class="menu-item"><span>Pohovana piletina čips/kornflex</span><span>15 KM</span></div>
            <div class="menu-item"><span>Nuggets pileći</span><span>9 KM</span></div>
            <div class="menu-item"><span>Kapsalon 125 gr</span><span>6 KM</span></div>
            <div class="menu-item"><span>Kapsalon</span><span>10 KM</span></div>
            <div class="menu-item"><span>Teleće pečenje sa krompirom</span><span>20 KM</span></div>
            <div class="menu-item"><span>Biftek sa prilogom</span><span>40 KM</span></div>
            <div class="menu-item"><span>Steak sa prilogom (cca 500gr)</span><span>25 KM</span></div>
          </div>
            <div class="tab-panel" id="pizza">
              <h3>Pizza</h3>
              
              <div class="menu-item"><span>Margherita</span><span>10 KM</span></div>
              <div class="menu-item"><span>Capricciosa</span><span>10 KM</span></div>
              <div class="menu-item"><span>Tonno</span><span>10 KM</span></div>
              <div class="menu-item"><span>Bosanska</span><span>13 KM</span></div>
              <div class="menu-item"><span>Vegetariana</span><span>10 KM</span></div>
              <div class="menu-item"><span>Kockica</span><span>14 KM</span></div>
              <div class="menu-item"><span>Doner pizaa+sos</span><span>13 KM</span></div>
              <div class="menu-item"><span>Margherita jumbo</span><span>15 KM</span></div>
              <div class="menu-item"><span>Capricciosa jumbo</span><span>18 KM</span></div>
              <div class="menu-item"><span>Bosanska jumbo</span><span>20 KM</span></div>
            </div>
              <div class="tab-panel" id="prilozi">
                <h3>Prilozi</h3>
                
                <div class="menu-item"><span>Pomfrit</span><span>3 KM</span></div>
                <div class="menu-item"><span>Pečeni krompir</span><span>3 KM</span></div>
                <div class="menu-item"><span>Pavlaka/kajmak</span><span>2 KM</span></div>
                <div class="menu-item"><span>Kečap</span><span>1 KM</span></div>
                <div class="menu-item"><span>Majoneza</span><span>1 KM</span></div>
                <div class="menu-item"><span>Senf</span><span>1 KM</span></div>
                <div class="menu-item"><span>Ajvar</span><span>2 KM</span></div>
                <div class="menu-item"><span>Tatar sos</span><span>2 KM</span></div>
                <div class="menu-item"><span>Sos od gljiva</span><span>2 KM</span></div>
                <div class="menu-item"><span>Kockica sos</span><span>3 KM</span></div>
                <div class="menu-item"><span>Masline</span><span>2 KM</span></div>
                <div class="menu-item"><span>Povrće sa roštilja 300 gr</span><span>5 KM</span></div>
                <div class="menu-item"><span>Peksimeti (5 kom)</span><span>1 KM</span></div>
                <div class="menu-item"><span>Peolivena lepina</span><span>1,50 KM</span></div>
              </div>
              <div class="tab-panel" id="salate">
              <h3>Salate</h3>
              <div class="menu-item"><span>Sezonska salata</span><span>3 KM</span></div>
              <div class="menu-item"><span>Šopska salata</span><span>4 KM</span></div>
              <div class="menu-item"><span>Kisela salata</span><span>3 KM</span></div>
            </div>
            <div class="tab-panel" id="sladoled">
              <h3>Sladoledi & Deserti & Palačinke</h3>
              <div class="menu-item"><span>Sladoled</span><span>2,50 KM</span></div>
              <div class="menu-item"><span>Voćna salata</span><span>5 KM</span></div>
              <div class="menu-item"><span>Palačinci sa Nutellom</span><span>6 KM</span></div>
              <div class="menu-item"><span>Palačinci Kinder Bueno</span><span>7 KM</span></div>
              <div class="menu-item"><span>Palačinci bijela čokolada</span><span>7 KM</span></div>
              <div class="menu-item"><span>Dubai palačinci</span><span>10 KM</span></div>
            </div>
            <div class="tab-panel" id="deserti">
              <h3>Kolači</h3>
              <div class="menu-item"><span>Medena torta</span><span>3 KM</span></div>
              <div class="menu-item"><span>Tri leće</span><span>3 KM</span></div>
              <div class="menu-item"><span>Cheesecake</span><span>4 KM</span></div>
              <div class="menu-item"><span>Rolat od banane</span><span>3 KM</span></div>
              <div class="menu-item"><span>Čokoaldni mousse</span><span>4 KM</span></div>
              <div class="menu-item"><span>Baklava</span><span>3 KM</span></div>
              <div class="menu-item"><span>Jabukovača</span><span>3 KM</span></div>
              <div class="menu-item"><span>Dounats</span><span>1 KM</span></div>
              <div class="menu-item"><span>Štrudlica</span><span>1 KM</span></div>
            </div>
            <div class="tab-panel" id="napitci">
              <h3>Topli napitci</h3>
              
              <div class="menu-item"><span>Espresso</span><span>2 KM</span></div>
              <div class="menu-item"><span>Bosanska kafa</span><span>2 KM</span></div>
              <div class="menu-item"><span>Nescafe classic</span><span>2 KM</span></div>
              <div class="menu-item"><span>Nescafe 3u1</span><span>2 KM</span></div>
              <div class="menu-item"><span>Topla čokolada</span><span>3 KM</span></div>
              <div class="menu-item"><span>Cappuccino</span><span>2 KM</span></div>
              <div class="menu-item"><span>Čaj</span><span>2 KM</span></div>
            </div>
              <div class="tab-panel" id="bezalkoholno">
              <h3>Bezalkoholno pivo</h3>
              
              <div class="menu-item"><span>Bavaria 0%</span><span>3 KM</span></div>
              <div class="menu-item"><span>Heineken 0%</span><span>3,50 KM</span></div>
            </div>
              <div class="tab-panel" id="prirodni">
              <h3>Prirodni sokovi</h3>
              
              <div class="menu-item"><span>Limunada</span><span>3 KM</span></div>
              <div class="menu-item"><span>Narandža cijeđena</span><span>4 KM</span></div>
              <div class="menu-item"><span>Mix limun + narandža</span><span>3,50 KM</span></div>
            </div>
              <div class="tab-panel" id="bezalkoholna">
              <h3>Bezalkoholna pića</h3>
              
              <div class="menu-item"><span>Prirodna voda Olimpija</span><span>2 KM</span></div>
              <div class="menu-item"><span>Prirodna voda Olimpija 0,75L</span><span>5 KM</span></div>
              <div class="menu-item"><span>Sarajevski kiseljak</span><span>2 KM</span></div>
              <div class="menu-item"><span>Sarajevski kiseljak 1L</span><span>5 KM</span></div>
              <div class="menu-item"><span>Coca Cola</span><span>3 KM</span></div>
              <div class="menu-item"><span>Coca Cola Zero</span><span>3 KM</span></div>
              <div class="menu-item"><span>Fanta narandža</span><span>3 KM</span></div>
            </div>
            <div class="tab-panel" id="alkohol">
              <h3>Alkoholna pića</h3>
              
              <div class="menu-item"><span>Stock</span><span>2 KM</span></div>
              <div class="menu-item"><span>Vodka</span><span>3 KM</span></div>
              <div class="menu-item"><span>Viljamovka</span><span>3 KM</span></div>
              <div class="menu-item"><span>Jagermeister</span><span>3 KM</span></div>
              <div class="menu-item"><span>Chivas</span><span>5 KM</span></div>
              <div class="menu-item"><span>Badel</span><span>2 KM</span></div>
              <div class="menu-item"><span>Vlahovac</span><span>2 KM</span></div>
              <div class="menu-item"><span>Pelinkovac</span><span>2 KM</span></div>
              <div class="menu-item"><span>Rakija</span><span>2 KM</span></div>
              <div class="menu-item"><span>Jack Daniels</span><span>5 KM</span></div>
              <div class="menu-item"><span>Hennessy</span><span>6 KM</span></div>
              <div class="menu-item"><span>Liker</span><span>3 KM</span></div>
            </div>
             <div class="tab-panel" id="pivo">
              <h3>Pivo</h3>
              
              <div class="menu-item"><span>Tuzlansko pivo</span><span>2,50 KM</span></div>
              <div class="menu-item"><span>Ožujsko pivo</span><span>3 KM</span></div>
              <div class="menu-item"><span>Heineken</span><span>4 KM</span></div>
              <div class="menu-item"><span>Karlovačko pivo</span><span>3 KM</span></div>
              <div class="menu-item"><span>Somersby</span><span>3,50 KM</span></div>
              <div class="menu-item"><span>Radler</span><span>3 KM</span></div>
              <div class="menu-item"><span>Tuborg</span><span>3,50 KM</span></div>
            </div>
             <div class="tab-panel" id="vino">
              <h3>Vino</h3>
              
              <div class="menu-item"><span>Vino bijelo Graševina 0,20L</span><span>7 KM</span></div>
              <div class="menu-item"><span>Vino bijelo Blatina 0,20L</span><span>7 KM</span></div>
              <div class="menu-item"><span>Vino crno Vranac Pro Corde 0,20L</span><span>7 KM</span></div>
              <div class="menu-item"><span>Vino crno Ždrepčeva krv 0,20L</span><span>7 KM</span></div>
              <div class="menu-item"><span>Vino bijelo Graševina 1L</span><span>30 KM</span></div>
              <div class="menu-item"><span>Vino crno/bijelo Žrepčeva krv 0,750L</span><span>20 KM</span></div>
              <div class="menu-item"><span>Vino crno Vranac Pro Corde 0,750L</span><span>35 KM</span></div>
              <div class="menu-item"><span>Vino crno Blatina 0,750L</span><span>30 KM</span></div>
              <div class="menu-item"><span>Vino crno Merlot 0,750L</span><span>30 KM</span></div>
            </div>
             <div class="tab-panel" id="plate">
              <h3>Hladne plate</h3>
              
              <div class="menu-item"><span>Hladna plata mala</span><span>20 KM</span></div>
              <div class="menu-item"><span>Hladna plata velika</span><span>40 KM</span></div>
            </div>
      </div>
    </div>
  </section>
</body>
</html>
